import React from 'react';
import { Button, Col, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import { useLocation, useNavigate } from 'react-router-dom';

//Components
import TabelaListagem from '../../../../components/TabelaListagem/TabelaListagem';

//Contants
import { actionsTable } from '../../../../constants/MaterialTable';
import { useEffect } from 'react';


function ListaInfracoes({ listInfracoes, handleVoltar, visualizarEtapaFiscalizacao, setVisualizarEtapaFiscalizacao }) {

    //Estado que pega os dados passados via navegação
    const location = useLocation();

    //Estado de navegação
    const navigate = useNavigate();

    useEffect(() => {
        if (location?.state && location?.state?.etapa) {
            const { etapa, tipoFiscalizacao } = location.state;
            setVisualizarEtapaFiscalizacao({ etapa: etapa, tipoFiscalizacao: tipoFiscalizacao })
        }

    }, [])


    const visualizar = (item) => {
        navigate("/admin/ficha-infracao", { state: { infracao_id: item.id, etapa: visualizarEtapaFiscalizacao.etapa, tipoFiscalizacao: visualizarEtapaFiscalizacao.tipoFiscalizacao, originPath: "/admin/listaInfracoes" } })
    }

    //Cabeçalhos da lista de consulta infração
    const headers = [
        { value: "Nome do infrator", objectValue: "nomeInfrator", align: "left" },
        { value: "Número da infração", objectValue: "numeroInfracao", align: "left" },
        {
            value: "Data da infração", objectValue: "dataInfracao", align: "left", options: {
                customBodyRenderLite: (dataIndex) => {
                    return <>{moment(listInfracoes[dataIndex]?.dataInfracao).format("DD/MM/YYYY HH:mm:ss")}</>
                }
            }
        },
        { value: "Endereço", objectValue: "enderecoCompleto", align: "left" },
        {
            value: "Data Limite", objectValue: "dataLimite", align: "left", options: {
                customBodyRenderLite: (dataIndex) => {
                    return <>{moment(listInfracoes[dataIndex]?.dataLimite).format("DD/MM/YYYY")}</>
                }
            }
        },
        { value: "Usuário", objectValue: "usuario_Nome", align: "left" },
        { value: "Processo", objectValue: "numeroProcesso", align: "left" },
        { value: "Situação", objectValue: "situacao", align: "left" }
    ];

    //Variavel que guarda as ações da tabela
    const actions = [actionsTable.visualizar(visualizar)];

    return <>
        <Row className='mb-2'>
            <Col md={12} lg={4}>
                <Button
                    onClick={() => navigate("/admin/dashboard")}
                    className='px-4'>
                    <FontAwesomeIcon icon={faAngleLeft} className='me-2' /> Voltar
                </Button>
            </Col>
        </Row>
        {listInfracoes.length > 0 &&
            <TabelaListagem
                actions={actions}
                title={`Lista ${visualizarEtapaFiscalizacao.etapa.toLowerCase()}`}
                options={{ print: false, search: true, pagination: true }}
                headers={headers}
                items={listInfracoes}
            />
        }
    </>;
}

export default ListaInfracoes;